import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  ON_MESSAGE,
  WS_CONNECTION,
} from './actions';
import { WEB_SOCKET_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

const initialState = {
  wsStatus: 2,
};

const reducer = handleActions({
  [WEB_SOCKET_MODULE + WS_CONNECTION + FAILED]: state => ({
    ...state,
    wsStatus: 2,
  }),
  [WEB_SOCKET_MODULE + WS_CONNECTION]: state => ({
    ...state,
    wsStatus: 1,
  }),
  [WEB_SOCKET_MODULE + WS_CONNECTION + SUCCESSFUL]: state => ({
    ...state,
    wsStatus: 0,
  }),
}, initialState);

export default reducer;

export const getWSData = createSelector(
  [state => state[WEB_SOCKET_MODULE]],
  state => {
    const {
      wsStatus,
    } = state;
    return {
      wsStatus,
    };
  },
);
